import { render, staticRenderFns } from "./banker-coverage.vue?vue&type=template&id=45e387bd"
import script from "./banker-coverage.vue?vue&type=script&lang=js"
export * from "./banker-coverage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports